import type { App } from 'vue';
import * as Sentry from '@sentry/vue';

const SENTRY_DSN = window.env?.VITE_SENTRY_DSN || import.meta.env.VITE_SENTRY_DSN;
const DEPLOY_ENV = window.env?.VITE_DEPLOY_ENV || import.meta.env.VITE_DEPLOY_ENV;

// eslint-disable-next-line import/prefer-default-export
export function initSentry(app: App<Element>) {
  Sentry.init({
    app,
    dsn: SENTRY_DSN,
    environment: DEPLOY_ENV,
  });
}
